let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ffCjG")).then(() => parcelRequire('kl7I8'));